"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M16.818 7.262l-4.264-1.47a1.707 1.707 0 00-1.11 0l-4.262 1.47a.84.84 0 00-.582.783v5.004c0 1.957 1.916 3.428 3.997 4.827a2.543 2.543 0 002.808 0c2.082-1.397 3.997-2.87 3.997-4.827V8.045a.845.845 0 00-.584-.783zm-5.9 7.079l-1.672-1.573.763-.718.91.855 3.072-2.888.763.718-3.836 3.606z" }), "Policies");
//# sourceMappingURL=Policies.js.map